/* jslint nomen: true */
// eslint-disable-next-line import/no-import-module-exports
import {debounce} from './custom-lodash';

const $ = require('jquery');

require('./uniform');

const packstation = {
    isCheckout: true,
    pscn: '.jsAddress1Packstation',
    ino: 'input[name$="_streetNo"]',
    ipr: '.is-packstation-row input',
    reqClass: 'required',
    indClass: 'required-indicator',

    /**
     * @function
     * @param {Object} $field - current form field
     * @param {string} value - value of the current form field
     * @param {boolean} required - is the field mandatory or not
     * @description updates 'Company' and 'StreetNo' fields to 'Postnummer' and 'Packstation Nr.'
     */
    updatePlaceholder($field, value, required) {
        const $label = $field.nextAll('label');
        const $span = $label.children(':first');
        let $req = $label.children(`.${this.indClass}`);
        if (!$field.data('placeholder-bck')) {
            // save original placeholder value
            $field.data('placeholder-bck', $span.html());
        }
        const fieldValue = value || $field.data('placeholder-bck');
        $span.html(fieldValue);
        // update required status
        if (required !== undefined) {
            $field.attr('placeholder', fieldValue + (required ? ` ${Resources.REQ_INDICATOR}` : ''));

            if (required) {
                if ($req.length === 0) {
                    $req = $(document.createElement('span')).addClass(this.indClass).append(Resources.REQ_INDICATOR);
                    $label.append($req);
                }
                $field.addClass(this.reqClass);
            } else {
                if ($req.length > 0) {
                    $req.remove();
                }
                $field.removeClass(this.reqClass);
            }
        } else {
            $field.attr('placeholder', fieldValue);
        }
    },

    /**
     * @function
     * @param {Object} $field - current form field
     * @description removes the validation-error class in order to prevent Front-end validation
     */
    removeError($field) {
        const $err = $field.nextAll('.error-msg');
        if ($err.length > 0) {
            $err.children().hide();
            $err.parent().removeClass('validation-error');
        }
    },

    /**
     * @function
     * @returns {Object} current form
     */
    getProperForm() {
        return $(this.isCheckout ? '.jsShippingAddressForm' : '#addressform');
    },

    /**
     * @function
     * @param {event} event - triggers when packstation checkbox is selected/deselected (on change)
     * @description changes the already updated fields (in {@link updatePlaceholder}):
     * 'Company' to 'Postnummer', 'StreetNo' to 'Packstation Nr.' and Street to Packstation
     */
    updateShippingForPackstation(event) {
        const $packstation = $(this.ipr);
        const $sform = this.getProperForm();
        const formfieldvalue = $sform.find('.jsMobileDevice').is(':visible') ? null : Resources.PACKSTATION_NO;
        const $saddress1 = $sform.find(`input[name$="_address1"]:not(${this.pscn})`);
        const $saddress1PS = $sform.find(this.pscn);
        const $sno = $sform.find(this.ino);
        const $saddress2 = $sform.find('input[name$="_address2"]');
        const $scountry = $sform.find('select[name$="_country"]');
        const $bform = $('.jsBillingAddressArea');
        if (!$sno.data('maxlength-bck')) {
            $sno.data('maxlength-bck', $sno.attr('maxlength'));
            $sno.data('type-bck', $sno.attr('type'));
        }
        if (!$saddress2.data('maxlength-bck')) {
            $saddress2.data('maxlength-bck', $saddress2.attr('maxlength'));
        }
        if ($packstation.is(':checked')) {
            $sform.find('.jsPackstationLink').show();
            if (this.isCheckout && event) {
                let salutation;
                let addressdata;
                let firstName;
                let lastName;
                const $selected = $bform.find('.jsAddressSelect:checked');
                if ($selected.length === 1) {
                    addressdata = $selected.data('address');
                }
                if (addressdata) {
                    salutation = addressdata.salutation;
                    firstName = addressdata.firstName;
                    lastName = addressdata.lastName;
                } else {
                    salutation = $bform.find('select[name$="_salutation"]').val();
                    firstName = $bform.find('input[name$="_firstName"]').val();
                    lastName = $bform.find('input[name$="_lastName"]').val();
                }
                $sform.find('select[name$="_salutation"]').val(salutation);
                $sform.find('input[name$="_firstName"]').val(firstName);
                $sform.find('input[name$="_lastName"]').val(lastName);
            }
            // hide label will filled-out class (see inputfields.js)
            this.removeError($saddress1); // field is now disabled; don't show errors
            $saddress1
                .removeClass('filled-out')
                .attr('disabled', 'disabled')
                .val($saddress1PS.removeAttr('disabled').val());
            // show only short label an mobile device
            this.updatePlaceholder($sno, formfieldvalue, true);
            $sno.attr('maxlength', '3');
            $sno.attr('type', 'number');
            this.updatePlaceholder($saddress2, Resources.POST_NO, true);
            $saddress2.attr('maxlength', '10');
            if (!this.isCheckout) {
                if ($scountry.data('packstation-countries')) {
                    const countries = JSON.parse(decodeURIComponent($scountry.data('packstation-countries')));
                    const $options = $scountry.find('option');
                    for (let i = 0; i < $options.length; i++) {
                        if ($($options[i]).val() && !countries[$($options[i]).val()]) {
                            // hide not supported in all browsers, so move options to other temporary element in DOM
                            if ($($options[i]).is(':selected')) {
                                // reset selection to default (empty) if current option is not available any more
                                $($options[0]).prop('selected', true);
                            }
                            $($options[i]).data('index', String(i)).appendTo('.jsCountryHolder');
                        }
                    }
                }
            }
        } else if ($packstation.length) {
            $sform.find('.jsPackstationLink').hide();
            $saddress1.removeAttr('disabled');
            $saddress1PS.attr('disabled', 'disabled');
            if (
                event &&
                ($(event.target).closest('.is-packstation-row').length > 0 ||
                    ($(event.target).closest('.use-same-address-row').length > 0 &&
                        $(event.target).closest('jsBillingAddressArea').length > 0))
            ) {
                $saddress1.val('');
            }
            $sno.attr('maxlength', $sno.data('maxlength-bck'));
            $sno.attr('type', $sno.data('type-bck'));
            this.removeError($saddress2); // isn't required anymore
            this.updatePlaceholder($saddress2, null, false);
            this.updatePlaceholder($sno, null, undefined); // use 'undefined' in case the field has an 'unrequiredindicator' attribute set to 'true'
            $saddress2.attr('maxlength', $saddress2.data('maxlength-bck'));
            if (!this.isCheckout) {
                const oval = $scountry.val();
                const $options = $('.jsCountryHolder').find('option');
                for (let i = 0; i < $options.length; i++) {
                    const ind = parseInt($($options[i]).data('index'), 10); /* eslint radix: "error" */
                    const child = $($scountry.children()[ind - 1]);
                    child.after($options[i]);
                }
                $scountry.val(oval);
            }
        }
        // re-init select label
        $.uniform.update();
    },

    /**
     * @function
     * @description calls {@link updatePlaceholder} when resizing the resoluton
     */
    initResize() {
        const that = this;
        $(window).on(
            'resize orientationchange',
            debounce(function () {
                const isPackstationCheckBox = $(that.ipr).is(':checked');
                const $currentForm = that.getProperForm();
                const $formField = $currentForm.find(that.ino);
                let formFieldValue = null;
                let isRequired;
                if (isPackstationCheckBox) {
                    const isJsMobileDeviceVisible = $currentForm.find('.jsMobileDevice').is(':visible');
                    if (!isJsMobileDeviceVisible) {
                        formFieldValue = Resources.PACKSTATION_NO;
                    }
                    isRequired = true;
                }
                that.updatePlaceholder($formField, formFieldValue, isRequired);
            }, 10)
        );
    }
};

module.exports = packstation;
